
































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import notificationService from "@/services/notificationService";
import tasksRepository from "@/modules/shared/tasks/tasksRepository";
import projectsRepository from "@/services/projectsRepository";
import cDatagrid from "@/components/default/Datagrid.vue";
import { DxSwitch } from "devextreme-vue/switch";
import dxCustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import TaskPopup from "@/modules/shared/tasks/components/TaskPopup.vue";
import employeesRepository from "@/modules/employees/employeesRepository";
import moment from "moment";

@Component({
  components: {
    cDatagrid,
    TaskPopup,
    DxSwitch,
  },
})
export default class TasksTable extends Vue {
  @Prop({ required: false })
  public projectId?: string;

  @Prop({ required: false, default: false })
  public myTasks!: boolean;

  @Prop({ required: false, default: false })
  public parentId?: string;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  public showOnlyMyTasks: boolean = true;
  public showClosedTasks: boolean = false;
  public employees: any[] = [];
  public employeesLoaded: boolean = false;

  private async mounted() {
    if (this.projectId || this.parentId) {
      this.showOnlyMyTasks = false;
      this.showClosedTasks = true;
    }
    this.employees = await this.getEmployees();
    this.employeesLoaded = true;
  }

  private addTask() {
    (this.$refs.TaskPopup as TaskPopup).show();
  }

  private refresh() {
    (this.$refs.grid as any).$refs.tasksTable.instance.refresh();
  }

  private openDetails(e: any) {
    if (
      e.row &&
      !e.row.isEditing &&
      e.column &&
      e.column.type !== "buttons" &&
      e.column.type !== "selection"
    ) {
      this.$router.push({ path: `/tasks/${e.row.data.id}`, query: { checkProjectOnHold: this.projectId ? 'false' : 'true' } });
    }
  }

  private onRowPrepared(e: any) {
    if (e.data && e.data.dueDate) {
      var dueDate = moment(new Date(e.data.dueDate)).format("YYYY-MM-DD");
      var nowDate = moment().format("YYYY-MM-DD");
      if (moment(dueDate).isSame(nowDate)) {
        e.rowElement.style.backgroundColor = "#ecac37";
      } else if (moment(dueDate).isBefore(nowDate)) {
        e.rowElement.style.backgroundColor = "#ff6347";
      }
    }
    if (e.data && e.data.status && e.data.status == 5) {
      e.rowElement.style.backgroundColor = "#00b216";
    }
  }

  private editTask(e: any) {
    this.$router.push({ path: `/tasks/${e.row.data.id}`, query: { checkProjectOnHold: this.projectId ? 'false' : 'true' } });
  }

  get datasource() {
    const self = this;
    return new DataSource({
      store: new dxCustomStore({
        key: "id",
        load: async (loadOptions) => {
          const command: ITaskLookupQuery = {
            parentId: self.parentId,
            onlyMyTasks: self.showOnlyMyTasks,
            includeClosed: self.showClosedTasks,
            projectId: self.parentId ? undefined : self.projectId,
            options: loadOptions,
          };
          const result = await tasksRepository.lookup(command);
          return {
            data: result.data.data,
            totalCount: result.data.totalCount,
          };
        },
      }),
      paginate: true,
    });
  }

  async getEmployees(){
    return (await employeesRepository.get()).data;
  }

  get toolbarOptions() {
    if (this.myTasks) {
      return [];
    }

    return [
      {
        location: "before",
        widget: "dxButton",
        options: {
          icon: "fas fa-plus",
          text: "Toevoegen",
          stylingMode: "outlined",
          type: "success",
          onClick: this.addTask,
        },
      },
    ];
  }

  get columns() {
    const employees = this.$store.getters["employees/items"];
    return [
      {
        dataField: "title",
        caption: this.$t("objects.tasks.fields.Title"),
      },
      {
        dataField: "userId",
        caption: this.$t("objects.tasks.fields.UserId"),
        lookup: {
          dataSource: employees,
          displayExpr: "displayName",
          valueExpr: "id",
        },
      },
      {
        dataField: "projectName",
        caption: this.$t("objects.tasks.fields.Project"),
      },
      {
        dataField: "customer.displayName",
        caption: this.$t("objects.tasks.fields.Customer"),
      },
      {
        dataField: "team",
        caption: "Team",
        lookup: {
          dataSource: employeesRepository.getTeams(),
          displayExpr: "text",
          valueExpr: "value",
          searchExpr: "value",
        },
      },
      {
        dataField: "category",
        caption: "Categorie",
        lookup: {
          dataSource:
            this.$store.getters["catalogs/list"]("TaskCategories").values,
          /*displayExpr: 'text',
          valueExpr: 'value',
          searchExpr: 'value',*/
        },
      },
      /*{
        dataField: 'type',
        caption: this.$t('objects.tasks.fields.Type'),
        lookup: {
          dataSource: [
            {value: 0, name: this.$t('objects.tasks.types.0')},
            {value: 1, name: this.$t('objects.tasks.types.1')},
            {value: 2, name: this.$t('objects.tasks.types.2')},
            {value: 3, name: this.$t('objects.tasks.types.3')},
            {value: 4, name: this.$t('objects.tasks.types.4')},
          ],
          displayExpr: 'name',
          valueExpr: 'value',
        },
      },*/
      {
        dataField: "status",
        caption: this.$t("objects.tasks.fields.Status"),
        lookup: {
          dataSource: [
            { value: 0, name: this.$t("objects.tasks.status.0") },
            { value: 1, name: this.$t("objects.tasks.status.1") },
            { value: 2, name: this.$t("objects.tasks.status.2") },
            { value: 3, name: this.$t("objects.tasks.status.3") },
            { value: 4, name: this.$t("objects.tasks.status.4") },
            { value: 5, name: this.$t("objects.tasks.status.5") },
          ],
          displayExpr: "name",
          valueExpr: "value",
        },
      },
      {
        dataField: "dueDateISO",
        caption: this.$t("objects.tasks.fields.DueDate"),
        dataType: "date",
        format: "dd/MM/yyyy",
      },
      {
        dataField: "createdBy",
        caption: this.$t("objects.tasks.fields.CreatedBy"),
        lookup: {
          dataSource: this.employees,
          displayExpr: "displayName",
          valueExpr: "adUserId",
        },
      },
      {
        type: "buttons",
        buttons: [
          {
            hint: "details",
            icon: "fas fa-eye",
            onClick: this.editTask,
          },
        ],
      },
    ];
  }

  @Watch("showClosedTasks")
  private onShowClosedTasksChanged() {
    this.refresh();
  }
  @Watch("showOnlyMyTasks")
  private onMyTasksChanged() {
    this.refresh();
  }
}
